<script setup lang="ts">
export interface BaseHeaderInvisibleLinksProps {
  links: IHeaderLink[];
}

const { t } = useI18n();
const route = useRoute();

const props = defineProps<BaseHeaderInvisibleLinksProps>();
const gridRows = computed(() => `grid-template-rows: repeat(${Math.min(props.links.length, 12)}, minmax(0, 1fr))`);
const popoverPlacement = computed(() => route.path.startsWith("/search") ? "bottom-right" : "bottom-left");
</script>

<template>
  <BasePopover
    v-if="props.links.length"
    class="hidden lg:flex items-center justify-center"
    content-class="background-main shadow-main rounded-main !w-auto overflow-hidden max-h-[600px]"
    :placement="popoverPlacement"
  >
    <template #default="{ toggle }">
      <BaseButton
        name="user-menu"
        type="icon"
        title="Menu"
        class="flex items-center justify-center w-10 baseHeaderInvisibleLinks__icon"
        @click="toggle"
      >
        <span class="item__dot" />
        <span class="item__dot mx-1" />
        <span class="item__dot" />
      </BaseButton>
    </template>
    <template #content="{ close }">
      <ul class="p-6 grid grid-flow-col gap-6" :style="gridRows">
        <li v-for="link in props.links" :key="link.id" class="max-w-[200px]">
          <BaseButton
            link
            full-width
            type="secondary"
            class="flex justify-between !no-underline"
            :tag="link.href.includes('http') ? 'a' : 'nuxt-link'"
            :to="link.href.includes('http') ? {} : link.href"
            :href="link.href.includes('http') ? link.href : undefined"
            :name="link.title"
            :title="link.title"
            @click.capture="close"
          >
            <p class="truncate hover:text-[var(--base-text-color)]">
              {{ link.id === 'following' || link.id === 'archive' ? t(`labels.${link.id}`) : link.title }}
            </p>
          </BaseButton>
        </li>
      </ul>
    </template>
  </BasePopover>
</template>

<style lang="scss">
//FIXME: Style
.baseHeaderInvisibleLinks__icon {
  .item__dot {
    @apply h-[5px] w-[5px] rounded-full inline-block flex-shrink-0;
    background-color: var(--base-secondary-color);
  }
  &:focus-within .item__dot {
    background-color: var(--base-text-color);
  }
}
</style>
